import { Calendar } from 'lucide-react';
import { format, subMonths, startOfMonth, endOfMonth, startOfQuarter, endOfQuarter, startOfYear, endOfYear, subQuarters, subYears } from 'date-fns';

export const PERIOD_PRESETS = [
  { value: 'current_month', label: 'Mese corrente', short: 'Mese corrente', getRange: () => ({ start: format(startOfMonth(new Date()), 'yyyy-MM-dd'), end: format(endOfMonth(new Date()), 'yyyy-MM-dd') }) },
  { value: 'last_month', label: 'Mese scorso', short: 'Mese scorso', getRange: () => ({ start: format(startOfMonth(subMonths(new Date(), 1)), 'yyyy-MM-dd'), end: format(endOfMonth(subMonths(new Date(), 1)), 'yyyy-MM-dd') }) },
  { value: 'current_quarter', label: 'Trimestre corrente', short: 'Trim. corrente', getRange: () => ({ start: format(startOfQuarter(new Date()), 'yyyy-MM-dd'), end: format(endOfQuarter(new Date()), 'yyyy-MM-dd') }) },
  { value: 'last_quarter', label: 'Trimestre scorso', short: 'Trim. scorso', getRange: () => ({ start: format(startOfQuarter(subQuarters(new Date(), 1)), 'yyyy-MM-dd'), end: format(endOfQuarter(subQuarters(new Date(), 1)), 'yyyy-MM-dd') }) },
  { value: 'current_year', label: 'Anno corrente', short: 'Anno corrente', getRange: () => ({ start: format(startOfYear(new Date()), 'yyyy-MM-dd'), end: format(endOfYear(new Date()), 'yyyy-MM-dd') }) },
  { value: 'last_year', label: 'Anno scorso', short: 'Anno scorso', getRange: () => ({ start: format(startOfYear(subYears(new Date(), 1)), 'yyyy-MM-dd'), end: format(endOfYear(subYears(new Date(), 1)), 'yyyy-MM-dd') }) },
  { value: 'last_6_months', label: 'Ultimi 6 mesi', short: 'Ultimi 6 mesi', getRange: () => ({ start: format(subMonths(new Date(), 6), 'yyyy-MM-dd'), end: format(new Date(), 'yyyy-MM-dd') }) },
  { value: 'last_12_months', label: 'Ultimi 12 mesi', short: 'Ultimi 12 mesi', getRange: () => ({ start: format(subMonths(new Date(), 12), 'yyyy-MM-dd'), end: format(new Date(), 'yyyy-MM-dd') }) },
];

export default function PeriodPresets({ activePreset, onPresetChange, showCustomDates, startDate, endDate, onStartDateChange, onEndDateChange, testIdPrefix = 'period' }) {
  return (
    <div data-testid={`${testIdPrefix}-presets-row`}>
      <div className="flex flex-wrap items-center gap-1.5">
        <Calendar className="w-3.5 h-3.5 text-gray-400 mr-0.5 shrink-0" />
        <button
          onClick={() => onPresetChange('all')}
          className={`px-2.5 py-1 rounded-full text-[11px] font-medium transition-all ${
            activePreset === 'all'
              ? 'bg-orange-500 text-white shadow-sm'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
          }`}
          data-testid={`${testIdPrefix}-preset-all`}
        >
          Tutto
        </button>
        {PERIOD_PRESETS.map(p => (
          <button
            key={p.value}
            onClick={() => onPresetChange(p.value)}
            className={`px-2.5 py-1 rounded-full text-[11px] font-medium transition-all ${
              activePreset === p.value
                ? 'bg-orange-500 text-white shadow-sm'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
            data-testid={`${testIdPrefix}-preset-${p.value}`}
          >
            {p.short}
          </button>
        ))}
        <button
          onClick={() => onPresetChange('custom')}
          className={`px-2.5 py-1 rounded-full text-[11px] font-medium transition-all ${
            activePreset === 'custom'
              ? 'bg-orange-500 text-white shadow-sm'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
          }`}
          data-testid={`${testIdPrefix}-preset-custom`}
        >
          Personalizzato
        </button>
        {showCustomDates && (
          <>
            <div className="flex items-center gap-1 ml-1">
              <span className="text-[10px] font-medium text-gray-400 uppercase">Da</span>
              <input type="date" value={startDate || ''} onChange={e => onStartDateChange(e.target.value)}
                className="h-7 text-xs border rounded-md px-2 w-[130px] bg-white" data-testid={`${testIdPrefix}-start-date`} />
            </div>
            <div className="flex items-center gap-1">
              <span className="text-[10px] font-medium text-gray-400 uppercase">A</span>
              <input type="date" value={endDate || ''} onChange={e => onEndDateChange(e.target.value)}
                className="h-7 text-xs border rounded-md px-2 w-[130px] bg-white" data-testid={`${testIdPrefix}-end-date`} />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
